import { Map, OrderedSet } from 'immutable';

import * as types from './types';

const initialState = new Map({
  items: new OrderedSet(),
  itemsCount: 0,
  loadingData: false,
  pagination: new Map({
    size: 30,
    activePage: 0,
  }),
});

const failureAnalysisReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.GET_FAILURE_TESTS.REQUEST:
      return state.set('loadingData', true);
    case types.GET_FAILURE_TESTS.SUCCESS:
      return state.withMutations((newState) => {
        const tmpItems = [...payload.items].sort(
          (itemLeft, itemRight) => itemLeft.total_runs < itemRight.total_runs,
        );
        const items = new OrderedSet(
          tmpItems.map((item) => ({
            name: item.name,
            avg_duration: item.avg_duration,
            total_runs: item.total_runs,
          })),
        );
        newState.set('items', items);
        newState.set('itemsCount', payload.all_items_count);
        newState.set('loadingData', false);
      });
    case types.GET_FAILURE_TESTS.FAILURE:
      return initialState;
    case types.CHANGE_PAGINATION:
      return state.set('pagination', payload);
    default:
      return state;
  }
};

export default failureAnalysisReducer;
export { initialState };
